var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantumDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "device_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 1745 l-395 -153 2 -164 c1 -89 5 -309 9 -488 l6 -325 500 -258 500 -257 378 260 378 260 6 328 c4 180 8 392 9 470 l2 144 -495 169 c-272 93 -497 168 -500 168 -3 0 -183 -69 -400 -154z m400 100 c0 -18 27 -20 32 -3 3 8 150 -38 439 -136 239 -82 440 -152 448 -156 9 -5 -15 -23 -73 -54 -47 -25 -124 -66 -170 -91 -70 -38 -85 -43 -90 -30 -7 20 -26 10 -26 -14 0 -13 -47 -43 -170 -109 l-170 -90 -85 36 c-76 33 -84 38 -79 59 7 27 -4 30 -21 7 -10 -15 -22 -12 -113 27 -77 33 -102 49 -102 63 0 15 -5 17 -27 13 -21 -5 -88 20 -275 101 -136 58 -245 109 -242 112 6 6 705 278 717 279 4 1 7 -6 7 -14z m-596 -364 c77 -34 147 -68 156 -76 9 -8 22 -15 29 -15 7 0 21 -10 32 -22 14 -17 21 -20 27 -10 6 9 53 -7 192 -67 101 -44 188 -87 192 -96 5 -8 14 -13 19 -9 18 11 97 -25 95 -44 -1 -17 6 -19 37 -7 16 7 17 -8 17 -223 0 -195 -2 -231 -15 -236 -19 -7 -19 -26 0 -26 13 0 15 -35 15 -251 l0 -251 -162 85 c-90 46 -297 153 -461 237 -248 128 -296 156 -283 166 32 23 11 46 -23 25 -8 -5 -10 -14 -6 -22 5 -10 5 -11 -2 -4 -7 6 -13 171 -18 464 -6 382 -5 453 6 448 8 -3 77 -33 153 -66z m1551 -383 c-4 -233 -11 -427 -16 -433 -5 -5 -9 -16 -9 -25 -1 -8 -144 -113 -336 -245 -185 -126 -340 -231 -345 -233 -5 -2 -9 106 -9 251 0 214 2 257 15 267 13 10 15 9 15 -9 0 -11 5 -21 10 -21 6 0 10 9 10 20 0 13 -9 22 -25 26 l-25 6 2 217 3 216 33 -3 c30 -3 45 12 20 20 -14 5 18 24 165 102 88 47 108 54 113 42 9 -24 24 -19 24 7 0 18 12 30 49 50 27 15 56 27 64 27 8 0 17 4 19 9 2 7 211 127 227 130 2 1 0 -189 -4 -421z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 1776 c0 -17 5 -26 16 -26 10 0 14 7 12 22 -5 32 -28 35 -28 4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 1696 c0 -17 5 -26 16 -26 10 0 14 7 12 22 -5 32 -28 35 -28 4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 1616 c0 -17 5 -26 16 -26 10 0 14 7 12 22 -5 32 -28 35 -28 4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 1536 c0 -17 5 -26 16 -26 10 0 14 7 12 22 -5 32 -28 35 -28 4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 1456 c0 -17 5 -26 16 -26 10 0 14 7 12 22 -5 32 -28 35 -28 4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514 1465 c-18 -14 -18 -14 3 -15 23 0 39 15 25 24 -5 3 -18 -1 -28 -9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566 1462 c-7 -12 22 -38 31 -28 4 3 0 14 -9 22 -9 10 -18 12 -22 6z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470 1420 c0 -24 15 -27 24 -4 9 22 8 24 -9 24 -8 0 -15 -9 -15 -20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905 1409 c-4 -6 -4 -13 -1 -16 8 -8 36 5 36 17 0 13 -27 13 -35 -1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 1380 c0 -19 11 -26 23 -14 8 8 -3 34 -14 34 -5 0 -9 -9 -9 -20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863 1383 c-15 -5 -18 -33 -4 -33 13 0 33 28 24 33 -4 2 -14 2 -20 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 1350 c0 -5 11 -10 25 -10 14 0 25 5 25 10 0 6 -11 10 -25 10 -14 0 -25 -4 -25 -10z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 1335 c0 -8 7 -15 15 -15 8 0 15 7 15 15 0 8 -7 15 -15 15 -8 0 -15 -7 -15 -15z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 1320 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 1385 c-3 -9 -3 -18 0 -21 9 -9 27 6 27 22 0 19 -19 18 -27 -1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 1344 c-9 -10 2 -24 19 -24 8 0 14 7 14 15 0 15 -21 21 -33 9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 1324 c3 -9 6 -18 6 -20 0 -2 5 -4 10 -4 6 0 10 9 10 20 0 12 -7 20 -16 20 -11 0 -14 -5 -10 -16z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 1284 c-7 -8 4 -44 14 -44 12 0 12 37 0 44 -4 3 -11 3 -14 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 1223 c-11 -10 -8 -43 3 -43 6 0 10 11 10 25 0 26 -2 29 -13 18z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 1179 c0 -5 5 -7 10 -4 6 3 10 -3 10 -14 0 -28 -3 -37 -12 -33 -5 1 -8 -2 -8 -8 0 -5 16 -10 35 -10 19 0 35 5 35 10 0 5 -4 9 -9 8 -10 -3 -11 1 -11 33 0 11 5 17 10 14 6 -3 10 -1 10 4 0 6 -16 11 -35 11 -19 0 -35 -5 -35 -11z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 1179 c0 -5 4 -8 8 -5 5 3 9 -8 10 -25 0 -16 -4 -27 -9 -24 -5 4 -9 1 -9 -4 0 -6 16 -11 35 -11 19 0 35 5 35 10 0 6 -6 10 -14 10 -9 0 -12 7 -9 20 3 11 9 20 14 20 5 0 9 5 9 10 0 6 -16 10 -35 10 -19 0 -35 -5 -35 -11z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 1145 c0 -14 5 -25 10 -25 6 0 10 11 10 25 0 14 -4 25 -10 25 -5 0 -10 -11 -10 -25z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937 1163 c-2 -5 -5 -23 -5 -41 -1 -43 22 -37 25 6 3 29 -10 52 -20 35z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 1150 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 1150 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980 1125 c0 -17 2 -18 24 -9 23 9 20 24 -4 24 -11 0 -20 -7 -20 -15z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 1104 c-7 -8 4 -44 14 -44 12 0 12 37 0 44 -4 3 -11 3 -14 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655 1080 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7 -4 -4 -10z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 1079 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10 -5 -10 -11z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 1058 c9 -9 15 -9 24 0 9 9 7 12 -12 12 -19 0 -21 -3 -12 -12z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 1030 c0 -11 7 -20 15 -20 17 0 18 2 9 24 -9 23 -24 20 -24 -4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 1020 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 983 c0 -5 4 -15 10 -23 11 -18 25 -7 17 15 -6 15 -27 21 -27 8z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 925 c4 -8 10 -15 15 -15 5 0 9 7 9 15 0 8 -7 15 -15 15 -9 0 -12 -6 -9 -15z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 877 c-9 -24 6 -44 18 -22 7 11 6 21 -1 28 -7 7 -12 6 -17 -6z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506 821 c-3 -5 -15 -7 -26 -4 -13 3 -22 -1 -26 -11 -9 -23 1 -30 25 -17 13 8 22 8 26 1 9 -15 25 -2 25 21 0 20 -15 26 -24 10z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 777 c-13 -10 -15 -16 -6 -21 17 -11 41 0 41 19 0 19 -11 19 -35 2z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 744 c0 -14 4 -23 10 -19 6 3 10 15 10 26 0 10 -4 19 -10 19 -5 0 -10 -12 -10 -26z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 735 c-10 -12 -9 -16 3 -21 20 -7 37 3 37 22 0 18 -24 18 -40 -1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 715 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0 -10 -7 -10 -15z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241 696 c-7 -9 -8 -17 -2 -20 14 -9 41 4 41 20 0 18 -24 18 -39 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494 696 c-4 -10 -2 -22 4 -28 8 -8 13 -7 18 6 4 10 2 22 -4 28 -8 8 -13 7 -18 -6z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878 683 c-20 -5 -24 -28 -8 -38 6 -3 13 1 16 10 4 10 13 13 26 9 15 -4 19 -2 16 7 -5 15 -23 19 -50 12z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 667 c-7 -12 -2 -15 27 -18 46 -4 70 1 70 14 0 15 -88 18 -97 4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 660 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0 -20 -4 -20 -10z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010 660 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0 -20 -4 -20 -10z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494 636 c-4 -10 -2 -22 4 -28 8 -8 13 -7 18 6 4 10 2 22 -4 28 -8 8 -13 7 -18 -6z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 610 c0 -11 4 -20 9 -20 11 0 22 26 14 34 -12 12 -23 5 -23 -14z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722 614 c1 -9 9 -19 16 -22 9 -3 13 2 10 14 -1 9 -9 19 -16 22 -9 3 -13 -2 -10 -14z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 616 c-4 -10 -2 -22 4 -28 8 -8 13 -7 18 6 4 10 2 22 -4 28 -8 8 -13 7 -18 -6z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506 581 c-4 -6 -3 -19 3 -28 9 -17 10 -17 17 0 8 21 -10 45 -20 28z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 574 c-8 -8 3 -34 14 -34 11 0 12 27 0 34 -4 3 -11 3 -14 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626 554 c-9 -22 -8 -24 9 -24 8 0 15 9 15 20 0 24 -15 27 -24 4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853 555 c-3 -9 -3 -18 0 -21 9 -9 27 6 27 22 0 19 -19 18 -27 -1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 519 c2 -7 10 -15 17 -17 8 -3 12 1 9 9 -2 7 -10 15 -17 17 -8 3 -12 -1 -9 -9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765 519 c-7 -10 10 -28 28 -29 12 0 8 17 -7 29 -11 9 -16 9 -21 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 510 c-8 -5 -11 -12 -8 -16 10 -9 38 3 38 16 0 12 -10 13 -30 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 510 c-8 -5 -11 -12 -8 -16 10 -9 38 3 38 16 0 12 -10 13 -30 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 1340 c0 -13 5 -20 13 -17 6 2 12 10 12 17 0 7 -6 15 -12 18 -8 2 -13 -5 -13 -18z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 1280 c0 -11 7 -20 15 -20 8 0 15 9 15 20 0 11 -7 20 -15 20 -8 0 -15 -9 -15 -20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490 1251 c0 -20 13 -35 23 -25 7 8 -4 44 -14 44 -5 0 -9 -9 -9 -19z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 1225 c-3 -9 -3 -18 0 -21 9 -9 27 6 27 22 0 19 -19 18 -27 -1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492 1193 c-8 -14 -9 -24 -2 -28 12 -7 24 18 18 37 -3 8 -9 5 -16 -9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593 1165 c-8 -22 6 -33 17 -15 13 20 12 30 0 30 -6 0 -13 -7 -17 -15z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 1141 c0 -12 29 -23 41 -15 5 3 7 10 4 15 -8 12 -45 12 -45 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463 1135 c-3 -9 -3 -18 0 -21 9 -9 27 6 27 22 0 19 -19 18 -27 -1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 1131 c0 -10 36 -21 44 -14 3 3 3 10 0 14 -7 12 -44 12 -44 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357 1124 c-10 -11 3 -24 24 -24 23 0 25 15 3 24 -19 7 -19 7 -27 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566 1114 c-4 -9 -4 -19 -2 -21 8 -8 26 8 26 23 0 19 -16 18 -24 -2z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410 1091 c0 -11 26 -22 34 -14 12 12 5 23 -14 23 -11 0 -20 -4 -20 -9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531 1066 c-8 -10 -9 -16 -1 -21 13 -8 30 3 30 21 0 18 -14 18 -29 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491 1017 c-6 -8 -8 -17 -4 -20 7 -8 33 11 33 24 0 13 -16 11 -29 -4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457 966 c-3 -8 -3 -17 0 -20 7 -7 33 13 33 25 0 15 -27 10 -33 -5z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442 913 c-8 -14 -9 -24 -2 -28 12 -7 24 18 18 37 -3 8 -9 5 -16 -9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437 863 c-11 -10 -8 -43 3 -43 6 0 10 11 10 25 0 26 -2 29 -13 18z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460 806 c0 -18 31 -29 44 -16 8 8 7 14 -4 20 -22 14 -40 12 -40 -4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430 780 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534 779 c-7 -12 12 -29 34 -29 18 0 15 27 -4 34 -21 8 -22 8 -30 -5z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 745 c0 -19 24 -30 41 -19 9 5 7 11 -6 21 -24 17 -35 17 -35 -2z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434 736 c-6 -17 2 -36 17 -36 12 0 12 37 -1 45 -6 3 -13 -1 -16 -9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 724 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308 732 c-16 -2 -28 -10 -28 -18 0 -16 16 -19 25 -4 5 8 11 8 20 0 10 -8 15 -8 20 0 10 17 -6 26 -37 22z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685 720 c-9 -15 4 -30 26 -30 25 0 25 16 0 30 -13 7 -22 7 -26 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754 689 c-8 -14 5 -29 27 -29 10 0 19 6 19 14 0 16 -37 28 -46 15z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282 663 c5 -25 28 -28 28 -4 0 12 -6 21 -16 21 -9 0 -14 -7 -12 -17z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 659 c0 -24 23 -21 28 4 2 10 -3 17 -12 17 -10 0 -16 -9 -16 -21z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442 666 c1 -10 8 -17 13 -17 15 1 12 24 -3 29 -9 3 -13 -2 -10 -12z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 611 c0 -11 5 -23 10 -26 6 -4 10 5 10 19 0 14 -4 26 -10 26 -5 0 -10 -9 -10 -19z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290 600 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 600 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450 600 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182 554 c1 -9 9 -19 16 -22 9 -3 13 2 10 14 -1 9 -9 19 -16 22 -9 3 -13 -2 -10 -14z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276 544 c-9 -22 -8 -24 9 -24 8 0 15 9 15 20 0 24 -15 27 -24 4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340 553 c0 -5 4 -15 10 -23 11 -18 25 -7 17 15 -6 15 -27 21 -27 8z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437 546 c-3 -8 -3 -17 0 -20 7 -7 33 13 33 25 0 15 -27 10 -33 -5z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222 508 c7 -19 38 -22 38 -4 0 10 -9 16 -21 16 -12 0 -19 -5 -17 -12z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 510 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0 -20 -4 -20 -10z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantumDevices);
export default __webpack_public_path__ + "static/media/quantumDevices.5bde07cda7e9c4d010a78be87cfb6754.svg";
export { ForwardRef as ReactComponent };